import React, { useEffect } from "react";
import { showToast, Timeline } from "../../../../../components";
import { dateFormator } from "../../../../../utils";

const Activities = ({ activities }) => {
  useEffect(() => {
    if (Array.isArray(activities) && activities.length === 0) {
      showToast("No activities found.", "error");
    }
  }, [])

  return (
    <div className="flex-1 p-4 mt-3 rounded-xl shadow-xl inner-section overflow-hidden">
      <div className="flex justify-between">
        <h6 className="text-base font-medium">Timeline</h6>
        <p className="text-xs font-normal text-gray-400 ">
          From ({dateFormator(activities?.[activities.length - 1]?.taskDate, "full")}) To ({dateFormator(activities?.[0]?.taskDate, "full")})
        </p>
      </div>
      <Timeline
        // data={[
        //   {
        //     task: "Account Created",
        //     taskBy: "Nethan",
        //     designation: "BDM",
        //     taskDate: "2025-07-10T00:00:00.000Z",
        //     applicant: "Mechael Vaughn",
        //   },
        //   {
        //     task: "Agreement Done",
        //     taskBy: "Aden",
        //     designation: "Recruiter",
        //     taskDate: "2025-07-01T09:30:00.000Z",
        //     applicant: "Johnson Clark",
        //   },
        //   {
        //     task: "Submit Job",
        //     taskBy: "Aden",
        //     designation: "Recruiter",
        //     taskDate: "2025-06-03T14:15:00.000Z",
        //     applicant: "Mechael Williamson",
        //   },
        //   {
        //     task: "Job created",
        //     taskBy: "Nethan",
        //     designation: "BDM",
        //     taskDate: "2025-05-04T11:45:00.000Z",
        //     applicant: "Mechael Williamson",
        //   },
        // ]}
        data={activities}
      />
    </div>
  );
};

export default Activities;
